var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.191 0h-8.191c-1.654 0-3 1.346-3 3v4h-3v-3.277c.595-.346 1-.984 1-1.723 0-1.105-.895-2-2-2s-2 .895-2 2c0 .738.405 1.376 1 1.723v5.277h5v2h-5v5.277c-.595.346-1 .984-1 1.723 0 1.105.895 2 2 2s2-.895 2-2c0-.738-.405-1.376-1-1.723v-3.277h3v9h3.975v-2h-1.975v-17c0-.551.448-1 1-1h7v6h6v2.101c.744.151 1.416.481 2 .922v-4.215zm.809 3.637 2.364 2.363h-2.364zm.879 9.242-6.879 6.878v4.243h4.242l6.879-6.878c.566-.567.879-1.32.879-2.122s-.313-1.555-.879-2.121c-1.17-1.17-3.072-1.17-4.242 0zm2.828 2.828-6.293 6.293h-1.414v-1.415l6.293-6.292c.391-.39 1.023-.39 1.414 0 .189.188.293.439.293.707s-.104.518-.293.707zm-4.777-3.707h-6.93v-2h10v.107c-.929.189-1.816.638-2.535 1.358zm-6.93 2h4.929l-2 2h-2.929z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartContract);
export default __webpack_public_path__ + "static/media/smart-contract.908912cef498cf2a1d8b911c67830470.svg";
export { ForwardRef as ReactComponent };